import { DUKE_HQ_SITE_NAME } from '@duke-hq/shared-constants/providers';

export default [
  {
    Site: 'Belconnen',
    State: 'Australian Capital Territory',
    States: 'ACT',
  },
  {
    Site: 'Canberra',
    State: 'Australian Capital Territory',
    States: 'ACT',
  },
  {
    Site: 'Canberra City',
    States: 'ACT',
    State: 'Australian Capital Territory',
  },
  {
    Site: 'Deakin',
    State: 'Australian Capital Territory',
    States: 'ACT',
  },
  {
    Site: 'Greenway',
    State: 'Australian Capital Territory',
    States: 'ACT',
  },
  {
    Site: 'Gungahlin',
    State: 'Australian Capital Territory',
    States: 'ACT',
  },
  {
    Site: 'Gunghalin',
    State: 'Australian Capital Territory',
    States: 'ACT',
  },
  {
    Site: 'Phillip',
    State: 'Australian Capital Territory',
    States: 'ACT',
  },
  {
    Site: 'Tuggeranong',
    State: 'Australian Capital Territory',
    States: 'ACT',
  },
  {
    Site: 'Wanniassa',
    State: 'Australian Capital Territory',
    States: 'ACT',
  },
  {
    Site: 'Woden',
    State: 'Australian Capital Territory',
    States: 'ACT',
  },
  {
    Site: 'Airds',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Albion Park',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Albury',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Armidale',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Arndell Park',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Ashfield',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Auburn',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Ballina',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Balranald',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bankstown',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bankstown - Disability Employment Services',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bargo',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Barham',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Barraba',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bateau Bay',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Batemans Bay',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bathurst',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Batlow',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Baulkham Hills',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Baulkham Hills (Outreach)',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bega',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bellambi',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bellingen',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Belmont',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Berala',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Berridale',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Berrigan',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bibbenluke',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Blacktown',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Blayney',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bomaderry',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bombala',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bondi Junction',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bonnyrigg',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Boorawa',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bossley Park',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Botany',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bowral',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Broadmeadow',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Broken Hill',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Brookvale',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Brunswick Heads',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bulli',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Bungarribee (Doonside)',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Burwood',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Byron Bay',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Cabramatta',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Camden',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Campbelltown',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Campsie',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Caringbah',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Carnes Hill',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Casino',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Castle Hill',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Castlereagh St',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Casula',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Cessnock',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Charlestown',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Chatswood',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Chester Hill',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Claymore',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Coffs Harbour',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Coffs Harbour - Disability Employment Services',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Condobolin',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Coolah',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Cooma',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Coonabarabran',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Coonamble',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Cootamundra',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Corowa',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Corrimal',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Cowra',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Cronulla',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Culcairn',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Dapto',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Darlinghurst',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Dee Why',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Deniliquin',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Doonside',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Dorrigo',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Dubbo',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Dunedoo',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Dungog',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'East Gardens',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'East Nowra',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Eastgardens',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Eastwood',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Eden',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Edgeworth',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Engadine',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Epping',
    States: 'NSW',
    State: 'New South Wales',
  },
  {
    Site: 'Ettalong Beach',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Fairfield',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Finley',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Forbes',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Forster',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Georges Hall',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Gilgandra',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Glen Innes',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Glenmore Park',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Glenwood',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Gosford',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Gosford - Disability Employment Services',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Goulburn',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Grafton',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Granville',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Green Valley',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Greenway',
    States: 'NSW',
    State: 'New South Wales',
  },
  {
    Site: 'Gregory Hills',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Grenfell',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Griffith',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Guildford',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Gulargambone',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Gundagai',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Gunnedah',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Guyra',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Hamilton',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Harden',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Hay',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Head Office',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Hillston',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Holbrook',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Horningsea Park',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Hornsby',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Hurstville',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Hurstville - Workforce Australia Services',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Ingleburn',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Inverell',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Jannali',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Jindabyne',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Junee',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Kandos',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Kanwal',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Katoomba',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Kempsey',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Kempsey - Disability Employment Services',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Kiama',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Kincumber',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Kingscliff',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Kingsford',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Kingswood',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Kogarah',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Kurri Kurri',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Kyogle',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Lake Cargelligo',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Lake Haven',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Lakemba',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Laurieton',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Leeton',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Leichhardt',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Lidcombe',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Lightning Ridge',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Lismore',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Lithgow',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Liverpool',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Liverpool - Disability Employment Services',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Lockhart',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Macksville',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Maclean',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Macquarie Fields',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Maitland',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Manilla',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Maroubra',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Marrickville',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Maryland',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Mayfield',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Menai',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Mendooran',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Merimbula',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Merriwa',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Merrylands',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Miller',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Miranda',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Moorebank',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Moree',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Morisset',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Moruya',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Moss Vale',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Mount Druitt',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Mt Druitt',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Mudgee',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Mullumbimby',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Mulwala',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Murwillumbah',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Muswellbrook',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Nambucca Heads',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Narellan',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Narooma',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Narrabri',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Narrandera',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Narromine',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Nelson Bay',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Newcastle',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Newtown',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Norfolk Island',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'North Ryde',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'North Strathfield',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'North Sydney',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Nowra',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Nyngan',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Oberon',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Oran Park',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Orange',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Padstow',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Panania',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Parkes',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Parramatta',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Peak Hill',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Penrith',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Picton',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Port Macquarie',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Prestons',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Punchbowl',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Pyrmont',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Quakers Hill',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Queanbeyan',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Quirindi',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Raymond Terrace',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Redfern',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Redfern - Workforce Australia Services',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Revesby',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Richmond',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Richmond - Disability Employment Services',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Richmond - Workforce Australia Services',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Riverwood',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Rockdale',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Rouse Hill',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Rozelle',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Ryde',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Salamander Bay',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'San Remo',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Sanctuary Point',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Scone',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Seven Hills',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Shellharbour',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Shellharbour City Centre',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Singleton',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'South Granville',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'South Tamworth',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Springwood',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'St Leonards',
    States: 'NSW',
    State: 'New South Wales',
  },
  {
    Site: 'St Marys',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Strathfield',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Summer Hill',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Surry Hills',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Sutherland',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Sydney',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tabulam',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tahmoor',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tamworth',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tamworth (Head Office)',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Taree',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Temora',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tenterfield',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'The Entrance',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Thornleigh',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tocumwal',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tooleybuc',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Toronto',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Toukley',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tregear',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tuggerah',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tumbarumba',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tumut',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tuncurry',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tweed Heads',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Tweed Heads South',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Ulladulla',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Ultimo',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Umina Beach',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Unanderra',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Villawood',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Vincentia',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Wagga Wagga',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Walcha',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Walgett',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Wallsend',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Warilla',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Warrawong',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Warren',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Warwick Farm',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Waterloo',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Wauchope',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Wee Waa',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Wellington',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Wentworthville',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'West Ryde',
    States: 'NSW',
    State: 'New South Wales',
  },
  {
    Site: 'West Wyalong',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Westmead',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Wetherill Park',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Windsor',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Wollongong',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Wollongong - Disability Employment Services',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Woolgoolga',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'World Square',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Woy Woy',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Wyoming',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Wyong',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Wyong (Outreach)',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Yamba',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Yass',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Young',
    State: 'New South Wales',
    States: 'NSW',
  },
  {
    Site: 'Alice Springs',
    State: 'Northern Territory',
    States: 'NT',
  },
  {
    Site: 'Berrimah',
    State: 'Northern Territory',
    States: 'NT',
  },
  {
    Site: 'Casuarina',
    State: 'Northern Territory',
    States: 'NT',
  },
  {
    Site: 'Darwin',
    State: 'Northern Territory',
    States: 'NT',
  },
  {
    Site: 'Darwin CBD',
    States: 'NT',
    State: 'Northern Territory',
  },
  {
    Site: 'Palmerston',
    State: 'Northern Territory',
    States: 'NT',
  },
  {
    Site: 'Palmerston City',
    State: 'Northern Territory',
    States: 'NT',
  },
  {
    Site: 'Tiwi (Casuarina)',
    State: 'Northern Territory',
    States: 'NT',
  },
  {
    Site: 'Acacia Ridge',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Agnes Waters',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Aitkenvale',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Alexandra Hills',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Arundel',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Atherton',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Ayr',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Banyo',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Baringa',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Beaudesert',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Beenleigh',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Beerwah',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Biloela',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Birtinya',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Blackwater',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Bokarina',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Bongaree',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Boonah',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Booval',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Bowen',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Bribie Island',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Brisbane City',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Browns Plains',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Buderim',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Bundaberg',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Bundaberg Central',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Bundaberg DES',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Bundaberg East',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Burleigh Heads',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Burleigh Water',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Burpengary',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Caboolture',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Cairns',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Cairns City',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Calamvale',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Caloundra',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Camira',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Cannonvale',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Capalaba',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Cardwell',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Carina',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Carindale',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Carrara',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Charters Towers',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Cherbourg',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Chermside',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Childers',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Chinchilla',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Cleveland',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Collinsville',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Coolangatta',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Coolum Beach',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Coomera',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Coominya',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Cooroy',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Corner',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Crows Nest',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Dalby',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Darra',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Deception Bay',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Deeragun',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Durong',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Eagleby',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Earlville',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Elanora',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Emerald',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Esk',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Eumundi',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Fernvale',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Forest Lake',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Fortitude Valley',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Gatton',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Gayndah',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Gaythorne',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Gin Gin',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Gladstone',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Gladstone Central',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Goodna',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Goondiwindi',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Gordonvale',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Grange',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Greenslopes',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Gympie',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Heatley',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Helensvale',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Idalia',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Imbil',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Inala',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Indooroopilly',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Ingham',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Innisfail',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Ipswich',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Jimboomba',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Kallangur',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Kenilworth',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Kilcoy',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Kilkivan',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Kingaroy',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Kippa-Ring',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Kirwan',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Labrador',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Laidley',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Lawnton',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Logan Central',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Logan Central (Woodridge)',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Lowood',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mackay',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mackay/ Mt Pleasant',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Malanda',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Maleny',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mareeba',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Margate',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Maroochydore',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Maryborough',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mermaid Beach',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Miami',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Miles',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Millmerran',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Milton',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mitchelton',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Monto',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Moorooka',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Moranbah',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Morayfield',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mossman',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mount Gravatt',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mount Isa',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mount Morgan',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mountain Creek',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mt Gravatt',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mt Isa',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mt Pleasant',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Mundingburra',
    States: 'QLD',
    State: 'Queensland',
  },
  {
    Site: 'Mundubbera',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Murarrie',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Murgon',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Murrumba Downs',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Nambour',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Nanango',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Nebo',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Nelly Bay',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Nerang',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Noosaville',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'North Ipswich',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'North Lakes',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'North Rockhampton',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'North Stradbroke (Dunwich)',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Nundah',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Oakey',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Ormeau',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Oxenford',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Pacific Pines',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Palm Beach',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Pialba',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Pialba (Hervey Bay)',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Pimpama',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Pittsworth',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Port Douglas',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Proserpine',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Proston',
    States: 'QLD',
    State: 'Queensland',
  },
  {
    Site: 'Raceview',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Rainbow Beach',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Rasmussen',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Ravenshoe',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Redbank Plains',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Redcliffe',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Redland Bay',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Richlands',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Riverview',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Robina',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Rockhampton',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Rockhampton City',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Rocklea',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Roma',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Rosewood',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Rubyvale',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Russell Island',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Sandgate',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Sarina',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'South Brisbane',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Southport',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Spring Hill',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Springfield',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Springfield Central',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Springfield Lakes',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'St George',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Stanthorpe',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: "Stone's Corner",
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Stones Corner',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Strathpine',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Sunnybank',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Surat',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Surfers Paradise',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Tara',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Tewantin',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Thuringowa',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Thuringowa Central',
    States: 'QLD',
    State: 'Queensland',
  },
  {
    Site: 'Tin Can Bay',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Tingalpa',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Toogoolawah',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Toowong',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Toowoomba',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Townsville',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Tully',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Tweed Heads South',
    States: 'QLD',
    State: 'Queensland',
  },
  {
    Site: 'Upper Coomera',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Upper Mount Gravatt',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Varsity Lakes',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Victoria Point',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Warwick',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'West End',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'West End (Townsville)',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Wilsonton',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Wishart',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Wongaling Beach',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Woodford',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Woodridge',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Woolloongabba',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Woorabinda',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Wynnum',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Yarrabah',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Yarrabilba',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Yarraman',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Yeppoon',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Zillmere',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Aberfoyle Park',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Adelaide',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Adelaide (CBD)',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Adelaide (Gawler Place)',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Aldgate',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Aldinga Beach',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Ardrossan',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Balaklava',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Barmera',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Berri',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Black Forest',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Blair Athol',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Bordertown',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Christies Beach',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Clare',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Clearview',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Clovelly Park',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Davoren Park',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Daw Park',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Dublin',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Elizabeth',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Elizabeth South',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Enfield',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Eudunda',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Fulham Gardens',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Fullarton',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Gawler',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Gawler East',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Glenelg',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Golden Grove',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Goolwa',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Hallett Cove',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Head Office - Kent Town',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Hillcrest',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Hindmarsh',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Ingle Farm',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Jamestown',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Kadina',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Kapunda',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Kilkenny',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Kingscote',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Lobethal',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Loxton',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Marion',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Mawson Lakes',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Meadows',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Melrose Park Operations',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Milang',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Mile End',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Millicent',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Modbury',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Morphett Vale',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Mount Barker',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Mount Gambier',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Mount Pleasant',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Mt Barker',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Munno Para',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Murray Bridge',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Naracoorte',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Noarlunga',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Noarlunga Centre',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Norwood',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Nuriootpa',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Oakbank',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Oaklands Park',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Ottoway',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Payneham',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Penola',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Peterborough',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Port Adelaide',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Port Augusta',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Port Lincoln',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Port Pirie',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Prospect',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Renmark',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Richmond SA',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Robe',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Rosewater',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Salisbury',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Salisbury North',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Seaford',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Strathalbyn',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Sturt',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Torrensville',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Tusmore',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Two Wells',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Victor Harbor',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Virginia',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Waikerie',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Warradale',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Whyalla',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Whyalla Norrie',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Willunga',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Woodville',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Yorketown',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Beaconsfield',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Bothwell',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Bridgewater',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Bridport',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Burnie',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Campbell Town',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Cape Barren Island',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Currie',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Cygnet',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Deloraine',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Devonport',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Gagebrook',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'George Town',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Glenorchy',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Hobart',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Huonville',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Huonville (Grove)',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Invermay',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Kettering',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'King Island',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Kings Meadows',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Kingston',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Launceston',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Mowbray',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'New Norfolk',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Nubeena',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Oatlands',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Queenstown',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Ravenswood',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Rokeby/Clarendon Vale',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Roseberry',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Rosebery',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Rosny',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Rosny Park',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Scottsdale',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Smithton',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Sorell',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'St Helens',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Strahan',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Swansea',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Triabunna',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Triabunna Outreach Centre',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Troublesmiths',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Ulverstone',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'West Ulverstone',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Whitemark',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Whitemark (Flinders Island)',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Zeehan',
    State: 'Tasmania',
    States: 'TAS',
  },
  {
    Site: 'Abbotsford',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Airport West',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Altona',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Altona Meadows',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Altona Meadows (DES)',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Altona North',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Apollo Bay',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Ararat',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Ascot Vale',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Aspendale',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Avoca',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Bacchus Marsh',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Bairnsdale',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Ballan',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Ballarat',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Ballarat Central',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Bannockburn',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Bayswater',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Beaufort',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Beechworth',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Belgrave',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Benalla',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Bendigo',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Blackburn',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Boronia',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Box Hill',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Bright',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Brighton',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Broadford',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Broadmeadows',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Brunswick',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Bulleen',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Bundoora',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Camberwell',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Campbellfield',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Camperdown',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Carlton',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Caroline Springs',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Carrum Downs',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Casterton',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Castlemaine',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Caulfield',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Caulfield North',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Chadstone',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Charlton',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Chelsea',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Cheltenham',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Churchill',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Clunes',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Clyde North',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Cobram',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Coburg',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Cohuna',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Colac',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Collingwood',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Corio',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Corryong',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Cowes',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Craigieburn',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Cranbourne',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Croydon',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Cudgewa',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Dandenong',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Daylesford',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Delacombe',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Doncaster',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Doncaster East',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Drouin',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Drysdale',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: DUKE_HQ_SITE_NAME,
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'East Geelong',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Echuca',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Endeavour Hills',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Ensay',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Epping',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Eskdale',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Ferntree Gully',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Fitzroy',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Flemington',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Footscray',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Foster',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Frankston',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Frankston North',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Geelong',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Gisborne',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Glen Waverley',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Glenroy',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Grantville',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Greensborough',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Grovedale',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Hastings',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Healesville',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Heathcote',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Heidelberg',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Heidelberg West',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Heywood',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Highton',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Hoppers Crossing',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Horsham',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Hurstbridge',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Inverloch',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'IrympleI',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Kangaroo Flat',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Kerang',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Kilmore',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Koo Wee Rup',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Kyabram',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Kyneton',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Lake Tyers',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Lakes Entrance',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Lalor',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Laverton',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Leongatha',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Lilydale',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Lorne (Outreach)',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Maffra',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Mallacoota',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Mansfield',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Marysville',
    States: 'VIC',
    State: 'Victoria',
  },
  {
    Site: 'Melbourne',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Melbourne - Corporate',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Melbourne CBD',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Melton',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Melton West',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Mentone',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Merbein',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Mernda',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Mickleham',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Mildura',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Moe',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Monbulk',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Moolap',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Moonee Ponds',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Moorabbin',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Mooroolbark',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Mooroopna',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Mornington',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Morwell',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Mount Waverley',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Myrtleford',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Narre Warren',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Neerim South',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Newcomb',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Newport',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Niddrie',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Noble Park',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Norlane',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'North Melbourne',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Northcote',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Numurkah',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Oakleigh',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Ocean Grove',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Omeo',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Orbost',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Ouyen',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Pakenham',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Paynesville',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Point Cook',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Port Melbourne',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Portland',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Prahran',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Preston',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Red Cliffs',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Register now',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Reservoir',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Ringwood',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Ringwood (Site 2)',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Robinvale',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Rosebud',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Rowville',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Roxburgh Park',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Rutherglen',
    States: 'VIC',
    State: 'Victoria',
  },
  {
    Site: 'Sale',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Sebastopol',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Seymour',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Shepparton',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'South Melbourne',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'South Morang',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'South Yarra',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Southbank',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Springvale',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'St Albans',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'St Arnaud',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'St Kilda',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Stawell',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Sunbury',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Sunshine',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Sunshine West',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Swan Hill',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Tallangatta',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Tarneit',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Tatura',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Taylors Lakes',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Terang',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Thomastown',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Torquay',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Traralgon',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Tullamarine',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Wallan',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Walwa',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Wangaratta',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Wantirna',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Wantirna South',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Warburton',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Warnambool',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Warracknabeal',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Warragul',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Warrnambool',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Watergardens',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Waurn Ponds',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Wendouree',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Werribee',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Whittlesea',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Wodonga',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Wollert',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Wonthaggi',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Woodend',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Yallam',
    States: 'VIC',
    State: 'Victoria',
  },
  {
    Site: 'Yarra Junction',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Yarram',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Yarrawonga',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Yea',
    State: 'Victoria',
    States: 'VIC',
  },
  {
    Site: 'Albany',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Alexander Heights',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Armadale',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Australind',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Banksia Grove',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Bassendean',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Bunbury',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Busselton',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Butler',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Byford',
    States: 'WA',
    State: 'Western Australia',
  },
  {
    Site: 'Byford (Disability Employment Services)',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Canning Vale',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Cannington',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Clarkson',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Cloverdale',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Cockburn Central',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Collie',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Coolbellup',
    States: 'WA',
    State: 'Western Australia',
  },
  {
    Site: 'Craigie',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Denmark',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Dunsborough',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Ellenbrook',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Esperance',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Falcon',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Forrestfield',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Fremantle',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Geraldton',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Gosnells',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Hamilton Hill',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Harrisdale',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Harvey',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Joondalup',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Kalgoorlie',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Katanning',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Kelmscott',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Kojonup',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Kwinana',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Lakelands',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Mandurah',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Manjimup',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Margaret River',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Merredin',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Midland',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Mirrabooka',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Moora',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Morley',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Mount Barker',
    States: 'WA',
    State: 'Western Australia',
  },
  {
    Site: 'Mount Hawthorn',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Narrogin',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Northam',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Northbridge',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Osborne Park',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Perth North',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Pinjarra',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Rockingham',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Shenton Park',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'South Lake',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Southern Cross',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Southern River',
    States: 'WA',
    State: 'Western Australia',
  },
  {
    Site: 'Stirling',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Success',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Thornlie',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Victoria Park',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Wanneroo',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Warnbro',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Warwick',
    States: 'WA',
    State: 'Western Australia',
  },
  {
    Site: 'Wellard',
    States: 'WA',
    State: 'Western Australia',
  },
  {
    Site: 'West Perth',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Willetton',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Yanchep',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Yangebup',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Hillcrest',
    State: 'Queensland',
    States: 'QLD',
  },
  {
    Site: 'Campbelltown',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Northgate',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Orbost',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Blackwood',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Fulham',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Mitchell Park',
    State: 'South Australia',
    States: 'SA',
  },
  {
    Site: 'Baldivis',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Belmont',
    State: 'Western Australia',
    States: 'WA',
  },
  {
    Site: 'Subiaco',
    State: 'Western Australia',
    States: 'WA',
  },
];
